'use client';

import { useEffect } from 'react';
import { analyticsConfig } from '../lib/analytics';

/**
 * Analytics component that loads Google Analytics 4
 * Only loads if analytics is enabled and GA4 ID is configured
 */
export function Analytics() {
    useEffect(() => {
        if (!analyticsConfig.enabled || !analyticsConfig.ga4Id) {
            return;
        }

        // Load Google Analytics script
        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsConfig.ga4Id}`;
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${analyticsConfig.ga4Id}', {
                page_path: window.location.pathname,
            });
        `;
        document.head.appendChild(script2);

        // Cleanup
        return () => {
            document.head.removeChild(script1);
            document.head.removeChild(script2);
        };
    }, []);

    return null;
}

